export default {"src":"/_next/static/media/icon-stats-intelligence.ae59cc4b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};